// Hover position types
export const hoverTypes = {
  BETWEEN_COLUMNS: 'BETWEEN_COLUMNS',
  BETWEEN_ROWS: 'BETWEEN_ROWS',
  IN_BOTTOM_WHITESPACE: 'OUTSIDE_BOTTOM_WHITESPACE',
  IN_LEFT_WHITESPACE: 'OUTSIDE_LEFT_WHITESPACE',
  IN_RIGHT_WHITESPACE: 'OUTSIDE_RIGHT_WHITESPACE',
  IN_TOP_WHITESPACE: 'OUTSIDE_TOP_WHITESPACE',
  INNER_TRIANGLE: 'INNER_TRIANGLE',
  OUTSIDE_LAYOUT_SECTION: 'OUTSIDE_LAYOUT_SECTION',
  IN_RECTANGLE_BOUNDS: 'IN_RECTANGLE_BOUNDS',
  BETWEEN_HORIZONTAL_STACK_CHILDREN: 'BETWEEN_HORIZONTAL_STACK_CHILDREN',
  BETWEEN_VERTICAL_STACK_CHILDREN: 'BETWEEN_VERTICAL_STACK_CHILDREN',
  BETWEEN_GRID_TABLE_CHILDREN: 'BETWEEN_GRID_TABLE_CHILDREN',
  BEFORE_CHILDREN: 'BEFORE_CHILDREN',
  AFTER_CHILDREN: 'AFTER_CHILDREN',
  SECTION_CONTAINER_LEFT_WHITESPACE: 'SECTION_CONTAINER_LEFT_WHITESPACE',
  SECTION_CONTAINER_RIGHT_WHITESPACE: 'SECTION_CONTAINER_RIGHT_WHITESPACE',
  SECTION_CONTAINER_TOP_WHITESPACE: 'SECTION_CONTAINER_TOP_WHITESPACE',
  SECTION_CONTAINER_BOTTOM_WHITESPACE: 'SECTION_CONTAINER_BOTTOM_WHITESPACE'
};
export const layoutNodeTypes = {
  GRID_LAYOUT_VERTICAL_STACK: 'GRID_LAYOUT_VERTICAL_STACK',
  GRID_LAYOUT_HORIZONTAL_STACK: 'GRID_LAYOUT_HORIZONTAL_STACK',
  GRID_LAYOUT_GRID: 'GRID_LAYOUT_GRID',
  GRID_LAYOUT_MODULE: 'GRID_LAYOUT_MODULE',
  GRID_LAYOUT_SECTION: 'GRID_LAYOUT_SECTION',
  GRID_LAYOUT_ROOT: 'GRID_LAYOUT_ROOT'
};
export const VERTICAL_CHILD_COLUMN_BUFFER_PERCENTAGE = 85;
export const LAYOUT_SECTION_OUTER_BUFFER_SIZE = 40;
export const GRID_LAYOUT_SECTION_CONTAINER_BUFFER_SIZE = 20;
const DEFAULT_STEP_DISTANCE_WIDTH = 0.05;
// The percentage to allocate for adding a row or column next to a module (per: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/7146)
const DEEPEST_ROW_STEP_DISTANCE_WIDTH = DEFAULT_STEP_DISTANCE_WIDTH;
// A value of 0.5 means that splitting modules between two columns will no longer be possible, since 0.5 will cover up half
// of the spaced allocated horizontally.
// Per: https://git.hubteam.com/HubSpot/ContentEditorUI/pull/8886
const DEEPEST_COLUMN_STEP_DISTANCE_WIDTH = 0.5;
export const bufferedCloseToEdgeDistancesWithoutNestedRows = {
  HORIZONTAL_GROUPING_EQUATION_FOR_INNER: {
    columnStepDistanceWidth: DEFAULT_STEP_DISTANCE_WIDTH,
    deepestColumnStepDistanceWidth: DEEPEST_COLUMN_STEP_DISTANCE_WIDTH
  },
  HORIZONTAL_GROUPING_EQUATION_FOR_LEAF: {
    columnStepDistanceWidth: DEFAULT_STEP_DISTANCE_WIDTH,
    deepestColumnStepDistanceWidth: DEEPEST_COLUMN_STEP_DISTANCE_WIDTH
  },
  VERTICAL_GROUPING_EQUATION_FOR_INNER: {
    rowStepDistanceHeight: DEFAULT_STEP_DISTANCE_WIDTH,
    deepestRowStepDistanceHeight: DEEPEST_ROW_STEP_DISTANCE_WIDTH
  },
  VERTICAL_GROUPING_EQUATION_FOR_LEAF: {
    value: 10000
  }
};
export const bufferedCloseToEdgeDistancesWithNestedRows = {
  HORIZONTAL_GROUPING_EQUATION_FOR_INNER: {
    columnStepDistanceWidth: DEFAULT_STEP_DISTANCE_WIDTH,
    deepestColumnStepDistanceWidth: DEFAULT_STEP_DISTANCE_WIDTH
  },
  HORIZONTAL_GROUPING_EQUATION_FOR_LEAF: {
    columnStepDistanceWidth: DEFAULT_STEP_DISTANCE_WIDTH,
    deepestColumnStepDistanceWidth: DEFAULT_STEP_DISTANCE_WIDTH
  },
  VERTICAL_GROUPING_EQUATION_FOR_INNER: {
    rowStepDistanceHeight: DEFAULT_STEP_DISTANCE_WIDTH,
    deepestRowStepDistanceHeight: DEFAULT_STEP_DISTANCE_WIDTH
  },
  VERTICAL_GROUPING_EQUATION_FOR_LEAF: {
    value: 10000
  }
};